import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppPages } from 'types/Enums';

const navItems = [
  { label: 'Feed', icon: 'explore', page: AppPages.SEARCH, navigate: AppPages.SEARCH },
  { label: 'Inbox', icon: 'chat_bubble', page: AppPages.INBOX, navigate: AppPages.INBOX },
  { label: 'Sent', icon: 'send', page: AppPages.OUTBOX, navigate: AppPages.OUTBOX },
  { label: 'Profile', icon: 'person', page: AppPages.PROFILE, navigate: AppPages.PROFILE }
];

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 left-0 w-full flex justify-around items-center h-20 px-4 z-50 bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md border-t border-primary/10"
      style={{ boxShadow: '0 -4px 20px rgba(233,68,95,0.15)' }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname.startsWith(item.page);
        return (
          <button
            key={item.label}
            onClick={() => navigate(item.navigate)}
            className={`flex flex-col items-center justify-center gap-1 px-4 py-1 rounded-xl transition-all active:scale-90 duration-150 ${
              isActive ? 'text-primary bg-primary/10' : 'text-primary/40 hover:text-primary'
            }`}
          >
            <span className="material-symbols-outlined" style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}>
              {item.icon}
            </span>
            <span className="font-bold text-[10px] tracking-widest uppercase">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
